// COMPONENTS
// import { ScrollToTop } from 'src/shared/components/atoms/scrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AppShell from '../../components/appShell';

const AppRoutesLayout = () => {
  return (
    <>
      <ToastContainer position='bottom-right' autoClose={5000} hideProgressBar={false} closeOnClick pauseOnHover draggable theme='colored' />
      {/* <ScrollToTop />  */}
      <AppShell />
      <ReactQueryDevtools initialIsOpen />
    </>
  );
};

export default AppRoutesLayout;
